export default __webpack_public_path__ + "static/whiteLogo-ae7320f9f7f6f909bad49938464726bf.png";